// extracted by mini-css-extract-plugin
module.exports = {"root":"bf_bx"};